import BaseAPI from '../base'

function getList(cafe_id, chain_id) {
    let query = {};
    if (cafe_id) query.cafe_id = cafe_id;
    if (chain_id) query.chain_id = chain_id;
    return BaseAPI.get('menu/list', query);
}

function create(data) {
    return BaseAPI.post('menu/create', data);
}

function update(id, menu) {
    return BaseAPI.post('menu/update', {
        menu_id: id,
        data: menu
    });
}

function remove(id) {
    return BaseAPI.post('menu/remove', {
        menu_id: id
    });
}

function clone(id, title) {
    return BaseAPI.post('menu/clone', {
        menu_id: id,
        title
    })
}

function rearrange(targets) {
    return BaseAPI.post(`menu/rearrange`, {
        targets
    });
}

function getPreviewToken(id) {
    return BaseAPI.get(`menu/preview/${id}`);
}

function addCategory(menu_id, name) {
    return BaseAPI.post(`menu/add_category`, {
        menu_id,
        name
    });
}


function getWithSettingsOnly(cafe_id, chain_id) {
    let query = {};
    if (cafe_id) query.cafe_id = cafe_id;
    if (chain_id) query.chain_id = chain_id;

    return BaseAPI.get(`menu/list/settings_only`, query);
}

function updatePayReceiverId(menu_id, pay_receiver_id) {
    return BaseAPI.post(`menu/change_pay_receiver/${menu_id}`, {
        pay_receiver_id
    });
}

function addProduct(menu_id, product) {
    return BaseAPI.post(`menu/editor/add_product/${menu_id}`, {
        product
    });
}

function updateProduct(menu_id, product_id, product) {
    return BaseAPI.post(`menu/editor/update_product/${menu_id}/${product_id}`, {
        product
    });
}

function removeProduct(menu_id, product_id) {
    return BaseAPI.post(`menu/editor/remove_product/${menu_id}/${product_id}`);
}

function duplicateCategory(menu_id, category_id) {
    return BaseAPI.post(`menu/editor/duplicate_category/${menu_id}/${category_id}`);
}

function moveCategory(menu_id, category_id, dst_menu_id) {
    return BaseAPI.post(`menu/editor/move_category/${menu_id}/${category_id}`, {
        dst_menu_id
    });
}

function stockifyItems(menu_id) {
    return BaseAPI.post(`menu/stockify_all_items/${menu_id}`);
}

export default {
  getList,
  create,
  update,
  remove,
  clone,
  rearrange,
  getPreviewToken,
  addCategory,
  getWithSettingsOnly,
  updatePayReceiverId,
  addProduct,
  updateProduct,
  removeProduct,
  duplicateCategory,
  moveCategory,
  stockifyItems,
};